







































































































































































































import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import {Component, Prop, Vue} from "vue-property-decorator";
import {mapGetters} from "vuex";
import {AxiosError} from "axios";
import Timeline from "@/components/timeline/_timeline.vue";
import AllGameCard from "@/components/pages/user/AllGameCard.vue";
import FollowerList from "@/components/pages/user/FollowerList.vue";
import FollowingList from "@/components/pages/user/FollowingList.vue";
import UserAvatar from "@/components/user/_userAvatar.vue";
import MetaSetting from "@/script/metaSetting";

@Component({
    components: {
        Swiper,
        SwiperSlide,
        Timeline,
        AllGameCard,
        FollowerList,
        FollowingList,
        UserAvatar
    },
    computed: {...mapGetters(["user"])},
})
export default class MyChannel extends Vue {
    metaSetting !: MetaSetting;
    TMSswiperOption = {
        slidesPerView: 'auto',
        spaceBetween: '0.2%',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        breakpoints: {
            300: {
                slidesPerView: 3.5
            },
            480: {
                slidesPerView: 3.5
            },
            768: {
                slidesPerView: 5.5
            },
            992: {
                slidesPerView: 7
            },
            1200: {
                //slidesPerView: 7
            }
        }
    }
    postCnt = 0;
    communityList = [];
    user!: any;
    media = '';

    mounted() {


        this.$store.dispatch("loginState")
            .then((res: any) => {
                if (res === 4) {
                    this.metaSetting = new MetaSetting({
                        title: `${this.$t('myChannel')} | Zempie.com`,
                        meta: [
                            {name: 'description', content: `${this.user.name} ${this.$t('myChannel.desc')}`}, //~의 채널입니다.
                            {property: 'og:url', content: `${this.$store.getters.homeUrl}/${this.$i18n.locale}/myChannel`},
                            {property: 'og:title', content: `${this.$t('myChannel')} | Zempie.com`},
                            {property: 'og:description', content: `${this.user.name} ${this.$t('myChannel.desc')}`},
                        ]
                    });
                    this.postCntFetch(this.user.id)
                    this.joinedComFetch(this.user.id)
                }
                else {
                    this.$router.push(`/${this.i18n.locale}/login`)
                }

            })
    }


    postCntFetch(userId: number) {
        this.$api.userPostCnt(userId)
            .then((res: number) => {
                this.postCnt = res;
            })
            .catch((err: AxiosError) => {

            })
    }

    joinedComFetch(userId: number) {
        this.$api.joinedCommunityList(userId)
            .then((res: any) => {
                this.communityList = res;
            })
            .catch((err: AxiosError) => {

            })
    }

    moveCommunity(id: string) {
        this.$router.push(`/${this.$i18n.locale}/community/${id}/timeline`)
    }

}
